import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import styles from './CustomSvgButtonWithTextStyles';

export default class CustomSvgButtonWithText extends Component {
  render() {
    const {
      onClick,
      buttonProps,
      buttonWidth,
      buttonHeight,
      iconPath,
      iconWidth,
      iconHeight,
      iconStyle,
      iconColor,
      iconProps,
      label,
      labelStyle,
      labelColor,
      lineBackground
      } = this.props;
    return (
      <FlatButton onClick={onClick} {...buttonProps}
                  style={_.assign({}, styles.button, {width: buttonWidth, height: buttonHeight, lineHeight: buttonHeight})}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-5px'}}>
          <span style={{height: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px'}}>
            <CustomSvgIcon path={iconPath}
                           width={iconWidth}
                           height={iconHeight}
                           color={iconColor}
                            {...iconProps}
                           style={_.assign({position: 'relative'}, iconStyle)}/>
            {lineBackground && <span style={{width: '30px', height: '5px', background: lineBackground}} />}
            </span>
          <span style={_.assign({}, styles.label, {color: labelColor}, labelStyle)}>{label}</span>
        </div>
      </FlatButton>
    );
  }
}

CustomSvgButtonWithText.propTypes = {
  onClick: PropTypes.func,
  buttonProps: PropTypes.object,
  buttonWidth: PropTypes.string.isRequired,
  buttonHeight: PropTypes.string.isRequired,
  iconPath: PropTypes.string.isRequired,
  iconWidth: PropTypes.string.isRequired,
  iconHeight: PropTypes.string.isRequired,
  iconProps: PropTypes.object,
  iconStyle: PropTypes.object,
  iconColor: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  labelStyle: PropTypes.object,
  lineBackground: PropTypes.string
};

CustomSvgButtonWithText.defaultProps = {
  buttonProps: {},
  buttonWidth: '60px',
  buttonHeight: '75px',
  iconWidth: '24px',
  iconHeight: '24px',
  iconStyle: {},
  iconProps: {},
  iconColor: Colors.grey300,
  labelColor: Colors.grey600
};